// Experiment for Forecasting Page

import { econometricsUsers, engineeringUsers, productUsers } from "./experiment-utils";

export const shouldEnableForecasting = (userEmail: string): boolean => {
  return [...engineeringUsers, ...productUsers, ...econometricsUsers].includes(userEmail);
};
